import type { Ref } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { BALANCES_PERMISSIONS } from '@modules/balances/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IBalancesItem,
} from '../types';
import {
  BALANCES_ITEM_QUERY_KEY,
  BALANCES_ITEM_URL,
} from '../constants';

export default function useBalancesItemQuery(
  id: Ref<number>,
): IContextQueryResult<IBalancesItem[], Error, IBalancesItem | undefined> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IBalancesItem[], Error, IBalancesItem | undefined>({
    queryKey: [BALANCES_ITEM_QUERY_KEY, id],
    queryFn: async ({ signal }) => fetchGet<IBalancesItem[]>(
      BALANCES_ITEM_URL,
      {
        signal,
        permission: BALANCES_PERMISSIONS.EDIT,
        urlParams: {
          id: id.value,
        },
      },
    ),
    select: (data) => data[0],
    enabled: computed(() => !!id.value),
  });
}
